import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import "./index.scss"

import { ConfigContainer } from "components"
import { Container, Title, Text, Select } from "components/Form"
import { competenceGroups, message } from "state_management"
import useT from "utils/hooks/useT"

// Configuration setup for competence groups.
export default function CompetenceGroupConfig({ group, onClose, nameCheck }) {
  const dispatch = useDispatch()
  const { t } = useT("common")
  const isMember = useSelector((state) => state.auth.isMember)
  const members = useSelector((state) => state.members)

  const [name, setName] = useState(group ? group.name : "")
  const [memberIds, setMemberIds] = useState(group ? group.memberIds : [])

  return (
    <ConfigContainer
      title={group ? t("editCompetenceGroup") : t("addCompetenceGroup")}
      submitHandler={() => {
        const msg = nameCheck(name, group ? group.name : "")
        if (msg) {
          dispatch(message.warning(msg))
          return
        }
        const res = { name, memberIds }
        if (group) {
          dispatch(competenceGroups.edit(group.id, res)).then(onClose)
        } else {
          dispatch(competenceGroups.create(res)).then(onClose)
        }
      }}
      cancelHandler={onClose}
    >
      <Container>
        <Title>{t("groupName")}</Title>
        <Text required disabled={isMember} value={name} onChange={setName} />
      </Container>
      <Container>
        <Title>{t("groupMembers")}</Title>
        <Select
          name={t("groupMembers")}
          required
          attr="initials"
          disabled={isMember}
          collection={Object.values(members).filter((member) => !member.archived)}
          value={memberIds}
          onChange={setMemberIds}
          menuPlacement={"bottom"}
          menuPosition={"fixed"}
        />
      </Container>
    </ConfigContainer>
  )
}
